import React from 'react'
import { Paragraph } from '@fs/zion-ui'

export default function BoldParagraph({ children, ...props }) {
  return (
    <Paragraph {...props}>
      <strong>{children}</strong>
    </Paragraph>
  )
}
